module.exports={
	"Form": "SampleExtendedSchema",
	"PickLists": [
		{
			"Hash": "ViewStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "ViewSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "ViewDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "ViewReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "ViewSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "ViewContainer",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "ViewContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "ViewSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "ViewSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "ViewSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "ViewSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "ViewLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleView",
				"Group": "SampleView",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "ViewStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleView",
				"Group": "SampleView",
				"SelectOptionsPickList": "ViewLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "ViewMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "ViewNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample View",
			"Hash": "SampleView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample View",
					"Hash": "SampleView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
